import { success } from '@/utils/alert'
import { mapActions } from 'vuex'

export default {
  ...mapActions(['updateUserData']),
  doActive () {
    if (!this.user.active) {
      this.$http.put('/v1/settings/profiles/me/account_active')
      .then(({data}) => {
        this.updateUserData(data)
        success('Seja bem vindo. Sentimos sua falta, sua conta acaba de ser reativada.')
      })
      .catch(({data}) => {
        this.errors = data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/resources/methods.js